module.exports = __webpack_public_path__ + "assets/img/25.0714ea61.png";